<template>
	<div v-if="!_gHlp.isEmpty(proposal) && !_gHlp.isEmpty(customer)">
		<CcrisTrackMiniCards :proposal="proposal" :customer_ctos="customer_ctos" />
		<FinalCommitmentSummary :proposal="proposal" :current_customer="customer" />

		<el-collapse v-model="activeNames" accordion class="border-0" @change="emitEvent">
			<el-collapse-item name="1" class="my-3">
				<div slot="title" class="collapse-header px-3">
					<h3 class="mb-0">Proposed on New Application Summary</h3>
				</div>
				<ProductApplication :psal_id="proposal.psal_id" :is_editable="false" />
			</el-collapse-item>

			<el-collapse-item name="2" class="yellow-header my-3">
				<div slot="title" class="collapse-header px-3">
					<h3 class="mb-0">Settlement Summary</h3>
				</div>
				<SettlementSummary :proposal="proposal" :is_editable="is_editable"/>
			</el-collapse-item>

			<el-collapse-item name="3" class="yellow-header my-3">
				<div slot="title" class="collapse-header px-3">
					<h3 class="mb-0">Proposed Repayment Sources</h3>
				</div>
				<RepaymentSources :psal_id="proposal.psal_id" :psal_invinity_id="proposal.psal_invinity_id" :is_editable="is_editable"/>
			</el-collapse-item>

			<el-collapse-item name="4" class="my-3">
				<div slot="title" class="collapse-header w-100">
					<b-row class="d-flex justify-content-between align-items-center mx-0">
						<b-col cols="6" md="4">
							<div class="d-flex align-items-center">
								<h3 class="mb-0 mr-2">KYC 1 ( Understand Your Financial Status )</h3>
							</div>
						</b-col>
						<b-col cols="6" md="6">
							<div class="d-none d-md-flex align-items-center float-right">
								<el-tooltip content="** By clicking this button, below total variable expenses will be blocked from further edit.">
									<p class="text-primary cursor-pointer"
										@click.stop="$refs.drawer_financial_analysis.viewFinancialAnalysis()">Preview Financial Analysis</p>
								</el-tooltip>
							</div>
							<div class="d-block d-md-none d-flex align-items-center float-right">
								<span class="text-primary cursor-pointer" @click.stop="$refs.drawer_financial_analysis.viewFinancialAnalysis()">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
										<path fill="currentColor"
											d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
									</svg>
								</span>
							</div>
						</b-col>
					</b-row>
				</div>
				<KYCSummary :proposal="proposal" :variable_expenses="customer_variable_expenses" :customer="customer" :has_report="existing_financial_proposal" />
			</el-collapse-item>

			<el-collapse-item name="5" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">KYC 2 (Understand Your Customer)</h3>
				</div>
				<KYCQuestion :psal_id="proposal.psal_id" :is_editable="is_editable" :proposal="proposal"/>
			</el-collapse-item>

			<el-collapse-item name="6" class="my-3">
				<div slot="title" class="collapse-header w-100">
					<b-row class="title d-flex justify-content-between align-items-center mx-0">
						<b-col cols="12" md="6">
							<h3 class="mb-0">Proposal Appendix</h3>
						</b-col>
						<b-col cols="12" md="6">
							<div class="d-flex align-items-center float-right">
								<el-button class="px-5" size="mini" type="warning" @click="generateAllAppendix" :loading="is_loading_appendix" >Generate</el-button>
							</div>
						</b-col>
					</b-row>
				</div>
				<ProposalAppendix ref="section_proposal_appendix" :proposal="proposal" />
			</el-collapse-item>
		</el-collapse>
		<ProposalActionButtons :proposal="proposal" />

		<!-- Drawer for Financial Analysis -->
		<DrawerFinancialAnalysis ref="drawer_financial_analysis" :proposal="proposal" :current_customer="customer" />
	</div>
</template>
<script>
import { Collapse, CollapseItem, Button, Dropdown, DropdownMenu, DropdownItem, Tooltip } from 'element-ui'
import { axios, services, getHeader, getKycHeader, swal } from '@/assets/js/httpImports.js'
import CcrisTrackMiniCards from '@/views/InitialProposal/SubDetails/SectionItems/CcrisTrackMiniCards'
import FinalCommitmentSummary from '@/views/InitialProposal/SubDetails/SectionItems/FinalCommitmentSummary'
import ProductApplication from '@/views/InitialProposal/SubDetails/SectionItems/ProductApplication'
import SettlementSummary from '@/views/InitialProposal/SubDetails/SectionItems/SettlementSummary'
import RepaymentSources from '@/views/InitialProposal/SubDetails/SectionItems/RepaymentSources'
import KYCSummary from '@/views/InitialProposal/SubDetails/SectionItems/KYCSummary'
import KYCQuestion from '@/views/InitialProposal/SubDetails/SectionItems/KYCQuestion'
import ProposalAppendix from '@/views/InitialProposal/SubDetails/SectionItems/ProposalAppendix'
import ProposalActionButtons from '@/views/InitialProposal/SubDetails/SectionItems/ProposalActionButtons'
import DrawerFinancialAnalysis from '@/views/InitialProposal/Drawers/DrawerFinancialAnalysis'

import { mapActions, mapState } from 'pinia'
import { useInitialProposalStore } from '@/stores/initialProposalStore'
import { useFinancialProposalStore } from '@/stores/financialProposalStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useKycStore } from '@/stores/kycStore'
import { usePMPStore } from '@/stores/pmpStore'
import { useNotificationStore } from '@/stores/notificationStore'

import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { IP_APPROVED_STATUSES } from '@/assets/js/status.js'

export default {
	props: ['proposal','customer', 'customer_ctos'],
	components: {
		CcrisTrackMiniCards,
		FinalCommitmentSummary,
		ProductApplication,
		SettlementSummary,
		RepaymentSources,
		KYCSummary,
		KYCQuestion,
		ProposalAppendix,
		ProposalActionButtons,
		DrawerFinancialAnalysis,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Tooltip.name]: Tooltip,
	},
	data() {
		return {
			IP_APPROVED_STATUSES: IP_APPROVED_STATUSES,
			is_submit_loading: false,
			banks: [],
			failed_cases: [],
			customer_variable_expenses: [],
			existing_financial_proposal: false,
			kyc_access_token: localStorage.kyc_token != null ? JSON.parse(localStorage.kyc_token) : null,
			activeNames: [],
			is_loading_appendix: false

		}
	},
	computed: {
		...mapState(useCustomerStore, ['current_eligibility']),
		...mapState(useFinancialProposalStore, ['financial_proposal','financialProposalDetail']),
		is_editable() {
			return !IP_APPROVED_STATUSES.includes(this.proposal.psal_main_status)
		}
	},
	mounted() {
		initialProposalEventBus.$on('sync-proposal', this.syncIncomeAndVarExpenses)
	},
	beforeUnmount() {
		initialProposalEventBus.$off('sync-proposal', this.syncIncomeAndVarExpenses)
	},
	watch: {
		customer(newVal) {
			if (newVal) {
				this.getEligibility()
			}
		},
		current_eligibility(newVal) {
			if (newVal) {
				this.banks = newVal.bank_eligibilities
			}
		},

	},
	created() {
		this.syncIncomeAndVarExpenses();
	},
	methods: {
		...mapActions(useInitialProposalStore, ['syncCustomerFinancial','generateAppendix']),
		...mapActions(useCustomerStore, ['getEligibility']),
		...mapActions(usePMPStore, ['checkCanCreatePMPCase']),
		...mapActions(useNotificationStore, ['createNotification']),
		...mapActions(useKycStore, ['getCustomerVariableExpenses']),
		...mapActions(useFinancialProposalStore, ['getFinancialProposal']),
		async checkFinancialProposal() {
			const store = useFinancialProposalStore()

			await axios.get(services.financial_proposal + 'check_exist_customer_financial_proposal_by_customer_id/' + this.proposal.psal_customer_id, { headers: getHeader() })
				.then(res => {
					this.existing_financial_proposal = res.data.data.existing_financial_proposal
					if(this.existing_financial_proposal) {
						store.financial_proposal = res.data.data.financial_proposal
					}
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
		},
		async emitEvent() {
			if(this.activeNames.includes("4")) {
				await this.syncIncomeAndVarExpenses()
			}
		},
		async syncIncomeAndVarExpenses(){
			if(!_gHlp.isEmpty(this.proposal) && (_gHlp.isEmpty(this.proposal.psal_client_accepted_date) || _gHlp.isEmpty(this.proposal.final_commitment_summary.detail_inflow.net_income))){
				this.customer_variable_expenses = await this.getCustomerVariableExpenses(this.customer.customer_id)
				
				let customer_income = this.customer.incomes.main;
				let customer_expenses_map = []
				
				if(!_gHlp.isEmpty(this.customer_variable_expenses) && !_gHlp.isEmpty(this.customer_variable_expenses.data)){
					if(this.customer_variable_expenses.data.length > 0){
						for (const cExp of this.customer_variable_expenses.data) {
							
							if((cExp.customer_category_name == 'Expenses') && (!_gHlp.isEmpty(cExp.customer_value))){
								customer_expenses_map.push({
									label:cExp.customer_question_column,
									amount_before:cExp.customer_month_value,
									amount_after:cExp.admin_month_value > 0 ? cExp.admin_month_value : cExp.customer_month_value,
								});
							}
						}
					}
				}

				await this.checkFinancialProposal()
				let financialIncomeData = {}
				if(this.existing_financial_proposal)
				{
					let financialDetail = await this.getFinancialProposal(this.proposal, this.customer)
					financialIncomeData = _gHlp.getValue(financialDetail,'customer_incomes.data');
				}
				
				let financial_income = {};
				if(!_gHlp.isEmpty(financialIncomeData)){
					for (const cInc of financialIncomeData) {
						let key_attribute = '';
						switch (cInc.income_type_title) {
							case "Basic Salary":
							case "Basic Salary + Variable Income" :
								key_attribute = 'monthly_salary';
								break;
							case "Fixed Allowance" :
								key_attribute = 'fixed_allowance';
								break;
							case "Avg Variable Income" :
								key_attribute = 'av_var_inc';
								break;
							case "Avg Commission" :
								key_attribute = 'av_com_inc';
								break;
							case "Avg Bonus" :
								key_attribute = 'av_bonus_inc';
								break;
							case "Rental Income" :
								key_attribute = 'total_rental_inc';
								break;
							case "Gross Income" :
								key_attribute = 'gross_income';
								break;
							case "Income Tax" :
								key_attribute = 'income_tax';
								break;
							case "Less:EPF Contribution" :
								key_attribute = 'epf';
								break;
							case "SOCSO" :
								key_attribute = 'sosco';
								break;
							case "Net Income" :
								key_attribute = 'net_income';
								break;
							default:
								continue;
								break;
						}

						financial_income[key_attribute] = {
							admin_value: cInc.admin_value == 0 || cInc.admin_value == null ? cInc.customer_value : cInc.admin_value,
							customer_value: cInc.customer_value
						}
					}
				}
				await this.syncCustomerFinancial(customer_income, customer_expenses_map, financial_income, this.proposal.psal_id);
			}
		},
		generateAllAppendix(){
			swal.fire({
						title: 'Are you sure?',
						text: "This will generate: Financial Plan, Customer Financial Statement & Investment Analysis",
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes, proceed!'
				}).then( async (result) => {
						if (result.isConfirmed) {
							this.is_loading_appendix = true;
							await this.generateAppendix(this.proposal.psal_id)
							_gNotif.notifySuccess('Appendix has been generated.');
							initialProposalEventBus.$emit('refresh-proposal-detail')
							this.is_loading_appendix = false;
						}
				})
			
		}
	}
}
</script>